import * as types from '../constants/assigneedetails'

const initialState = {
  Status: null,
  apiGetResult: null,
  apiPostResult: null,
  assigneedetails: null,
  assigneedetailsList: null,
  assigneeuserList: null
}

export function assigneeDetails(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_ASSIGNEE_REQUEST:
      return {
        ...initialState,
        Status: true
      };
    case types.FETCH_ASSIGNEE_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiGetResult: true,
        assigneedetails: action.data
      };
    case types.FETCH_ASSIGNEE_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiGetResult: false,
        // assigneedetailsList:action.error
      };
    case types.FETCH_ASSIGNEE_RESET:
      return {
        ...state,
        Status: null,
        apiGetResult: null,
        assigneedetailsList: null,
        assigneedetails: null,
      };
    case types.FETCH_ASSIGNEE_LIST_REQUEST:
      return {
        ...initialState,
        Status: true
      };
    case types.FETCH_ASSIGNEE_LIST_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiGetResult: true,
        assigneedetailsList: action.data
      };
    case types.FETCH_ASSIGNEE_LIST_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiGetResult: false
      };
      case types.FETCH_ASSIGNEE_USER_LIST_REQUEST:
        return {
          ...state,
          Status: true
        };
      case types.FETCH_ASSIGNEE_USER_LIST_REQUEST_COMPLETED:
        return {
          ...state,
          Status: false,
          apiGetResult: true,
          assigneeuserList: action.data
        };
      case types.FETCH_ASSIGNEE_USER_LIST_REQUEST_ERROR:
        return {
          ...state,
          Status: false,
          apiGetResult: false,
          // assigneedetailsList:action.error
        };
    case types.ADD_ASSIGNEE_RESET:
      return {
        ...initialState,
        Status: null,
        apiPostResult: null
      };
    case types.ADD_ASSIGNEE_REQUEST:
      return {
        ...initialState,
        Status: true
      };
    case types.ADD_ASSIGNEE_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiPostResult: true
      };
    case types.ADD_ASSIGNEE_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiPostResult: false
      };
    default:
      return state;
  }
} 


// WEBPACK FOOTER //
// ./reducers/assigneedetails.js